module.exports = __webpack_public_path__ + "img/care_main2.2d3afcc8.png";